import { type FC, useState } from "react";

import { DocumentKindEnum } from "@app_schema";

import { Menu } from "@styled/menu";
import { MenuItemButton } from "@styled/menu_item_button";
import { MenuItems } from "@styled/menu_items";
import { MenuTrigger } from "@styled/menu_trigger";
import { Modal } from "@styled/modal";
import { ModalClose } from "@styled/modal_close";
import { ModalContent } from "@styled/modal_content";
import { ModalHeader } from "@styled/modal_header";
import { ModalTitle } from "@styled/modal_title";

import { DraftingUploadChoice } from "../drafting_upload_choice";
import { useProjectDocumentSave } from "../use_project_document_save";

// The Word draft's name over the Report, with a menu to upload a different
// Word file (for this case only, or as his template; the Report then shows
// it) and, once he has a template, to edit it (`onEditTemplate`).
export const DraftFileMenu: FC<{
  projectId: string;
  name: string;
  onEditTemplate?: () => void;
}> = ({ projectId, name, onEditTemplate }) => {
  const save = useProjectDocumentSave(projectId);
  const [uploading, setUploading] = useState(false);
  const close = () => setUploading(false);

  return (
    <>
      <Menu>
        <MenuTrigger>{name}</MenuTrigger>
        <MenuItems anchor="bottom start" fit>
          <MenuItemButton size="sm" onClick={() => setUploading(true)}>
            Upload a different Word file
          </MenuItemButton>
          {onEditTemplate && (
            <MenuItemButton size="sm" onClick={onEditTemplate}>
              Edit your template
            </MenuItemButton>
          )}
        </MenuItems>
      </Menu>
      {uploading && (
        <Modal onClose={close}>
          <ModalHeader>
            <ModalTitle>Upload a different Word file</ModalTitle>
            <ModalClose onClose={close} />
          </ModalHeader>
          <ModalContent>
            <DraftingUploadChoice
              save={async (blob, role) => {
                await save(blob, DocumentKindEnum.ReportDraft, role);
                close();
              }}
            />
          </ModalContent>
        </Modal>
      )}
    </>
  );
};
